import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { AppState } from '../store';
import { isAnyAdmin, selectAllCourses, selectUser } from '../store/selectors';
import { isAnonymousUser } from '../models/user.model';

export const courseWatchAccessGuard: CanActivateFn = (route) => {
  const store = inject(Store<AppState>);
  const router = inject(Router);
  const courseUrl = route.paramMap.get('courseUrl');

  return combineLatest([
    store.pipe(select(selectUser)),
    store.pipe(select(selectAllCourses)),
    store.pipe(select(isAnyAdmin)),
  ]).pipe(
    filter(([user]) => !!user),  // wait until auth state is determined
    first(),
    map(([user, courses, admin]) => {
      if (admin) return true;

      const course = courses.find(c => c.url === courseUrl);

      // Course not yet in store (direct navigation) → allow; resolver + API will gate access
      if (!course) return true;

      // Free course → always allow
      if (course.free) return true;

      // Anonymous user trying to access a paid course → redirect to course landing page
      if (isAnonymousUser(user)) {
        return router.parseUrl(`/courses/${courseUrl}`);
      }

      // Logged-in user on a paid course → allow; template shows "Buy Now" if not purchased
      return true;
    })
  );
};
